const customerSearchType = {
  customer: 'T',
  company: 'C',
}
export default customerSearchType
